import { faHashtag } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { InteractiveHeaderIconStyles , GeneralHeaderIcon  } from './TableStyle';
import { faEnvelope, faPaperclip, faUser, faSearch, faArrowDownShortWide, faArrowUpWideShort } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import DEFAULT_TABLE_COLOR from '../../GlobalStyles';

interface TableIconsProps {
  icon: any;
  tooltip: string;
  onClick?: React.MouseEventHandler;
  active?: boolean;
  bgColor?: string;
}

export const TableIcon: React.FC<TableIconsProps & { styledIcon?: any}> = ({ styledIcon, icon, tooltip, onClick, active, bgColor=DEFAULT_TABLE_COLOR }) => (
  <>
    <Tooltip id="col-head-tooltip" place="top" />
    {React.createElement(styledIcon, {
      icon,
      'data-tooltip-id': 'col-head-tooltip',
      'data-tooltip-content': tooltip,
      'data-tooltip-place': 'top',
      onClick,
      active,
      bgColor,
    })}
  </>
);
//
export const LettersHeaderIcon = () => (
  <TableIcon styledIcon={GeneralHeaderIcon} icon={faEnvelope} tooltip="Letters" />
);

export const AttachmentsHeaderIcon = () => (
  <TableIcon styledIcon={GeneralHeaderIcon} icon={faPaperclip} tooltip="Attachments" />
);

export const SendersHeaderIcon = () => (
  <TableIcon styledIcon={GeneralHeaderIcon} icon={faUser} tooltip="Senders" />
);

export const SendersIcon = () => (
  <TableIcon styledIcon={GeneralHeaderIcon} icon={faUser} tooltip="Senders"/>
);

export const HashtagHeaderIcon = () => (
  <TableIcon styledIcon={GeneralHeaderIcon} icon={faHashtag} tooltip="Number" />
);

export const SearchHeaderIcon = ({ onClick, active, bgColor }: { onClick?: React.MouseEventHandler; active?: boolean; bgColor?: string }) => (
  <TableIcon styledIcon={InteractiveHeaderIconStyles} icon={faSearch} tooltip="Search" onClick={onClick} active={active} bgColor={bgColor} />
);

export const SortHeaderIcon = ({ direction, onClick, active, bgColor }: { direction: 'asc' | 'desc'; onClick?: React.MouseEventHandler; active?: boolean; bgColor?: string }) => (
  <TableIcon
    styledIcon={InteractiveHeaderIconStyles}
    icon={direction === 'asc' ? faArrowUpWideShort : faArrowDownShortWide}
    tooltip={`Sort ${direction === 'asc' ? 'Ascending' : 'Descending'}`}
    onClick={onClick}
    active={active}
    bgColor={bgColor}
  />
);


